<template>
  <div class="tab-container" :style="{ height: maxHeight - 100 + 'px' }">
    <multi-selection-toolbar
      :layer="layer"
      :can-modify-objects="canModifyObjects"
      :can-generate-request="canGenerateRequest"
      :closure-delete="closureDelete"
      @closeDialogDeleteClosure="closureDelete.dialogOpen = false"
    />

    <multi-selection-table
      :layer="layer"
      @loadingObjects="$emit('loadingObjects', $event)"
      :can-highlight-objects="canHighlightObjects"
      @closureDelete="closureDelete = $event"
    />
  </div>
</template>

<script>
import MultiSelectionToolbar from "./MultiSelectionToolbar";
import MultiSelectionTable from "./MultiSelectionTable";

export default {
  name: "MultiSelectionTab",

  components: {
    MultiSelectionTable,
    MultiSelectionToolbar
  },

  props: {
    layer: {
      type: String,
      required: true
    },

    maxHeight: Number,

    canModifyObjects: {
      type: Boolean
    },

    canGenerateRequest: {
      type: Boolean
    },

    canHighlightObjects: {
      type: Boolean
    }
  },

  data() {
    return {
      loading: true,

      closureDelete: {
        dialogOpen: false,
        associatedCables: null
      }
    };
  }
};
</script>

<style scoped>
.tab-container {
  min-height: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/MultiSelectionForm/MultiSelectionTab.vue